/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} User_List_Showing_TotalInputs */



/**
* | output |
* | --- |
* | "Showing {count} users" |
*
* @param {User_List_Showing_TotalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_showing_total = /** @type {((inputs: User_List_Showing_TotalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Showing_TotalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Affichage de ${i?.count} utilisateurs`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Mostrando ${i?.count} usuarios`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Mostrando ${i?.count} usuários`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Mostrati ${i?.count} utenti`)
	return /** @type {LocalizedString} */ (`Showing ${i?.count} users`)
});